import { EmbedderConfig } from "../../../index";

const isSameEmbedder = (
  embedder: EmbedderConfig,
  embedderArray: EmbedderConfig[],
) => {
  return embedderArray.some(
    ({ aiTitle, active, useSegmentation }) =>
      aiTitle === embedder.aiTitle &&
      active === embedder.active &&
      useSegmentation === embedder.useSegmentation,
  );
};

export const isSameEmbedderConfig = (
  oldConfig: EmbedderConfig[],
  newConfig: EmbedderConfig[],
) => {
  return oldConfig
    .map((embedder) => isSameEmbedder(embedder, newConfig))
    .reduce((accumulator, currentValue) => accumulator && currentValue, true);
};
